import { useCallback } from 'react';
import { usePatronSelector } from '../common/use-patron-selector';

/**
 * A hook that provides functionality to check if a link is internal to the current application.
 *
 * @returns An object containing:
 *   - isInternalLink: Function to check if a URL is internal
 *   - isLegacyLink: Function to check if a URL is a legacy sc4 link
 */
export const useInternalLinkChecker = () => {
  const program = usePatronSelector((state) => state.program);

  const isLegacyLink = useCallback((url: URL) => {
    const path = url.pathname.split('/');
    return path.pop() === 'sc4' && url.hash.length > 0; // e.g. /sc4?query=2#contents/123
  }, []);

  const isInternalLink = useCallback(
    (url: URL) => {
      const sameHostname = url.hostname === window.location.hostname;
      const isStandardInternalLink =
        sameHostname && url.pathname.startsWith(program.root_path);
      const isCustomDomainInternalLink =
        sameHostname && program.is_custom_domain;

      return (
        isStandardInternalLink ||
        isCustomDomainInternalLink ||
        isLegacyLink(url)
      );
    },
    [program.root_path, program.is_custom_domain, isLegacyLink]
  );

  return {
    isInternalLink,
    isLegacyLink,
  };
};
